import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import './RoleSelection.css';

const RoleSelection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { roles = [], blocked = [], userId } = location.state || {};

  const [availableRoles, setAvailableRoles] = useState([]);

  useEffect(() => {
    // Filter out blocked roles to show only active ones
    const activeRoles = roles.filter((role) => !blocked.includes(role));
    setAvailableRoles(activeRoles);

    // If no active roles, redirect back to login
    if (activeRoles.length === 0 && roles.length > 0) {
      toast.error('Your account has been restricted. Contact the administrator.');
      navigate('/login');
    }
    
    // If no roles at all, redirect back to login
    if (!roles || roles.length === 0) {
      toast.error('No roles found. Please login again.');
      navigate('/login');
    }
  }, [roles, blocked, navigate]);

  const handleRoleSelection = (role) => {
    // Store selected role in localStorage
    localStorage.setItem('selectedRole', role);

    const redirectURL = getRedirectURL(role);
    
    toast.success(`Role Selected: ${role}. Redirecting...`, {
      autoClose: 800,
    });
    
    // Use setTimeout to allow toast to show before navigation
    setTimeout(() => {
      // Use window.location.href for hard navigation to ensure page loads
      window.location.href = redirectURL;
    }, 800);
  };

  // Function to return redirect URL based on role
  const getRedirectURL = (role) => {
    // Normalize role to lowercase for comparison
    const normalizedRole = role?.toLowerCase();
    
    switch (normalizedRole) {
    case 'instructor':
      return '/dashboard';
    case 'user':
      return '/home';
    case 'university':
    case 'university-student':
    case 'universitystudent':
      return '/university-courses';
    default:
      return '/home';
    }
  };

  return (
    <div className="role-selection-container">
      <h2>Choose Your Path</h2>
      <p>Pick your role and continue your journey.</p>

      <div className="role-buttons">
        {availableRoles.length > 0 ? (
          availableRoles.map((role, index) => (
            <button
              key={index}
              className="role-button"
              onClick={() => handleRoleSelection(role)}
            >
              {role.charAt(0).toUpperCase() + role.slice(1)} Dashboard
            </button>
          ))
        ) : (
          <p>No available roles.</p>
        )}
      </div>
    </div>
  );
};

export default RoleSelection;
